import styled from 'styled-components'
import { xs } from 'utils/style-utils'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: ${xs}px;
  padding-top: 1rem;
  word-wrap: break-word;
`
